import { useCallback, useState } from 'react';
import {
  DEALERSHIP_PHONE_DISPLAY,
  DEALERSHIP_PHONE_E164,
  DEALERSHIP_PHONE_TEL_URI,
} from '../../constants/dealershipContact';

/** True when tel: should open the device Phone app (not desktop FaceTime). */
export function isMobilePhoneDevice() {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/**
 * Phone link: tel: on mobile (Phone app). On desktop/Mac, copies number — avoids FaceTime.app from tel:.
 */
export default function DealershipPhoneLink({
  className,
  children,
  copyLabel = 'Phone number copied',
  ...rest
}) {
  const [copied, setCopied] = useState(false);
  const mobile = isMobilePhoneDevice();

  const copyNumber = useCallback(async (e) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(DEALERSHIP_PHONE_E164);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard unavailable — number remains visible in the UI
    }
  }, []);

  const label = children ?? DEALERSHIP_PHONE_DISPLAY;
  const title = copied
    ? copyLabel
    : mobile
      ? `Call ${DEALERSHIP_PHONE_DISPLAY}`
      : `Call ${DEALERSHIP_PHONE_DISPLAY} — click to copy`;

  if (mobile) {
    return (
      <a href={DEALERSHIP_PHONE_TEL_URI} className={className} title={title} {...rest}>
        {label}
      </a>
    );
  }

  return (
    <a
      href="#call"
      role="button"
      className={className}
      title={title}
      onClick={copyNumber}
      {...rest}
    >
      {label}
    </a>
  );
}
